import styled from "styled-components";
import dropDownArrowIcon from "../../../assets/icons/dropDownArrowIcon.svg";
import { pxToRem } from "../../../styles/utils";

export const DropdownContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DropdownInput = styled.input`
  padding: ${pxToRem(12)} ${pxToRem(16)};
  font-size: ${pxToRem(17)};
  border: ${pxToRem(1)} solid rgba(31, 10, 53, 0.1);
  border-radius: ${pxToRem(10)};
  background: rgb(247, 248, 248);
  cursor: pointer;
  width: 100%;

  &:focus {
    border: ${pxToRem(1)} solid rgb(114, 82, 220);
    outline: none;
    background: rgba(114, 82, 220, 0.15);
  }
`;

export const DropdownIcon = styled.span<{ isOpen: boolean }>`
  position: absolute;
  right: ${pxToRem(16)};
  top: 50%;
  transform: translateY(-50%)
    rotate(${({ isOpen }) => (isOpen ? "180deg" : "0deg")});
  transition: transform 0.2s ease-in-out;
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
  background: url(${dropDownArrowIcon}) no-repeat center center;
  background-size: contain;
  cursor: pointer;
`;

export const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  border-radius: ${pxToRem(10)};
  background: rgb(249, 249, 249);
  padding: ${pxToRem(13)} ${pxToRem(16)};
  z-index: 10;
  box-shadow: 0 ${pxToRem(4)} ${pxToRem(6)} rgba(0, 0, 0, 0.1);
  width: auto;

  /* Ограничиваем высоту и включаем прокрутку */
  max-height: ${pxToRem(150)}; /* Ограничьте высоту списка */
  overflow-y: scroll; /* Включаем вертикальную прокрутку */

  /* Убираем скроллбар */
  &::-webkit-scrollbar {
    display: none; /* Скрываем скроллбар для браузеров с поддержкой Webkit */
  }
  -ms-overflow-style: none; /* Скрываем скроллбар для IE и Edge */
  scrollbar-width: none; /* Скрываем скроллбар для Firefox */
`;

export const DropdownItem = styled.li`
  padding: ${pxToRem(13)} 0;
  cursor: pointer;
  list-style: none;
  font-size: ${pxToRem(17)};

  &:hover {
    color: rgb(114, 82, 220);
  }
`;
